const PlayerPauseIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M6 4H7V13H4V4ZM10 4H12V13H9V4Z" fill="currentColor"/>
        </svg>
    )
}

export default PlayerPauseIcon;